function openInNewTab(link) {
  return link ? window.open(link, '_blank') : false;
}

export { openInNewTab };
